import { InlineTool, SanitizerConfig } from '@editorjs/editorjs';

export default class UppercaseTool implements InlineTool {
  static isInline = true;
  static title = 'Uppercase';

  static get sanitize(): SanitizerConfig {
    return {
      span: {
        style: true
      }
    } as SanitizerConfig;
  }

  private button: HTMLButtonElement | null = null;
  private readonly CSS = {
    button: 'ce-inline-tool',
    buttonActive: 'ce-inline-tool--active',
  };

  render(): HTMLElement {
    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.classList.add(this.CSS.button);
    this.button.innerHTML = `<svg width="17" height="10" viewBox="0 0 17 10" xmlns="http://www.w3.org/2000/svg">
      <text x="0" y="9" fill="currentColor" font-size="10" font-weight="bold" font-family="sans-serif">TT</text>
    </svg>`;

    return this.button;
  }

  surround(range: Range): void {
    if (!range) {
      return;
    }

    // Check if we're inside an uppercase span
    const existingSpan = this.findUppercaseSpan(range.commonAncestorContainer);

    if (existingSpan) {
      // Remove uppercase styling
      this.unwrap(existingSpan);
    } else {
      // Add uppercase styling
      const selectedText = range.extractContents();
      const span = document.createElement('span');
      span.style.textTransform = 'uppercase';
      span.appendChild(selectedText);
      range.insertNode(span);
    }
  }

  checkState(): boolean {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
      return false;
    }

    const range = selection.getRangeAt(0);
    const span = this.findUppercaseSpan(range.commonAncestorContainer);

    const isActive = !!span;

    if (this.button) {
      this.button.classList.toggle(this.CSS.buttonActive, isActive);
    }

    return isActive;
  }

  private findUppercaseSpan(node: Node): HTMLElement | null {
    if (!node) {
      return null;
    }

    // Check if current node is a span with text-transform: uppercase
    if (node.nodeType === Node.ELEMENT_NODE) {
      const element = node as HTMLElement;
      if (element.tagName === 'SPAN' && element.style.textTransform === 'uppercase') {
        return element;
      }
    }

    // Check parent nodes
    if (node.parentElement) {
      return this.findUppercaseSpan(node.parentElement);
    }

    return null;
  }

  private unwrap(element: HTMLElement): void {
    const parent = element.parentNode;
    if (!parent) {
      return;
    }

    while (element.firstChild) {
      parent.insertBefore(element.firstChild, element);
    }
    parent.removeChild(element);
  }
}
